import { LINK_WHITELIST } from '../constants';

export function isNumber(input:any):boolean {
	return typeof input === 'number';
}

export function isHexCode(str:string):boolean {
	const regexp = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
	if (regexp.test(str)) {
		return true;
	}
	else {
		return false;
	}
}

export function isString(value:any):boolean {
	return typeof value === 'string';
}


// Link Validation
export function isValidLink(str: string, addon?: string[]): boolean {
	return isUrl(str) || isSpecialLink(str, addon) || hasOtherProtocol(str);
}

export function isSpecialLink(str: string, addon?: string[]): boolean {
	const isInAddon = addon ? isIn(addon, str) : false;
	return isInWhitelist(str) || hasSpecialPrefix(str) || isInAddon;
}

// Common Link
export function isUrl(str: string): boolean {
	if (str == null) return false;

	let domain = str;
	if (hasHttp(domain)) {
		domain = domain.split('://')[1];
	}

	if (hasPath(domain)) {
		// path는 모든 문자를 허용하므로 체크하지 않음
		domain = domain.split('/')[0];
	}

	const isValidDomain = checkDomain(domain);
	return isValidDomain;
}

export function hasPath(str: string): boolean {
	let value = hasHttp(str) ? str?.split('://')[1] : str;
	value = value?.split('/')[1];
	return value != null;
}

export function hasOtherProtocol(str: string): boolean {
	if (hasHttp(str)) return false;
	return str?.includes('://') || false;
}

export function hasHttp(str: string): boolean {
	return HTTP_PROTOCOLS.some((prefix) => str?.indexOf(prefix + '://') === 0);
}
const HTTP_PROTOCOLS = ['http', 'https'];

export function checkDomain(str: string): boolean {
	if (str == null) return false;

	const pattern = /^([a-zA-Z0-9](([-a-zA-Z0-9]{1,254})?([a-zA-Z0-9]))?\.)+[a-zA-Z0-9](([-a-zA-Z0-9]{1,254})?([a-zA-Z0-9]))?(:[0-9]{1,5})?$/;
	const isValidFormat = pattern.test(str);

	const isValidLength = str.length >= 2 && str.length <= 63;

	return isValidFormat && isValidLength;
}

// Special Link
export function hasSpecialPrefix(str: string): boolean {
	return TEL_PREFIXES.some((prefix) => str?.indexOf(prefix) === 0);
}
const TEL_PREFIXES = ['tel:', 'fax:', 'sms:', 'callto:', 'mailto:'];


export function isInWhitelist(str: string): boolean {
	return isIn(LINK_WHITELIST, str);
}

export function isIn(list: string[], str: string): boolean {
	return list.includes(str);
}